import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import Swal from 'sweetalert2';
import { FaGlobe } from 'react-icons/fa';

const MobileSidebar = () => {
    const { t } = useTranslation();
    const currentLanguage = i18n.language;

    const selectlanguage = async () => {
        const inputOptions = new Promise((resolve) => {
            resolve({
                'pt': generateLanguageOption('Português', 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/255px-Flag_of_Portugal.svg.png'),
                'en': generateLanguageOption('English', 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flag_of_the_United_Kingdom_%281-2%29.svg/255px-Flag_of_the_United_Kingdom_%281-2%29.svg.png'),
                'es': generateLanguageOption('Español', 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Bandera_de_Espa%C3%B1a.svg/255px-Bandera_de_Espa%C3%B1a.svg.png'),
                'fr': generateLanguageOption('Français', 'https://upload.wikimedia.org/wikipedia/en/thumb/c/c3/Flag_of_France.svg/250px-Flag_of_France.svg.png'),
                'it': generateLanguageOption('Italiano', 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Flag_of_Italy.svg/255px-Flag_of_Italy.svg.png')
            });
        });

        function generateLanguageOption(languageName, flagImageUrl) {
            return `<div style="display: flex; flex-direction: column; align-items: center;">${languageName}</div><div style="display: flex; justify-content: center;"><img src="${flagImageUrl}" style="height: 40px; width: auto;" /></div>`;
        }

        const result = await Swal.fire({
            title: t('Select a language'),
            input: 'radio',
            // Use the currentLanguage state for inputValue
            inputValue: currentLanguage,
            inputOptions: inputOptions,
            customClass: 'customClassModalLinguas',
            inputValidator: (value) => {
                if (!value) {
                    return t('obrigatorio_escolher_opcao');
                }
            }
        });

        if (result.isConfirmed) {
            const selectedLanguage = result.value;
            // IMPORTANT: Use the consistent key 'language' here
            localStorage.setItem('language', selectedLanguage); // Store the language value in LocalStorage

            i18n.changeLanguage(selectedLanguage, (err, t) => {
                if (err) return console.error('something went wrong loading the language', err);
                // The languageChanged event listener in useEffect will update currentLanguage state
            });
        }
    };

    return (
        <>
            {/* Sidebar */}
            <div className="offcanvas offcanvas-end active-dark-mode" tabIndex="-1" id="mobileSidebar" aria-labelledby="mobileSidebarLabel" style={{ backgroundColor: "var(--dark-main-body)" }}>
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="mobileSidebarLabel">{t("Menu")}</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    <ul className="navbar-nav">
                        <li className="nav-item"><Link className="nav-link" to="/lentreprise">{t("L'entreprise")}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/referance">{t("Referance")}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/contact">{t("Contact")}</Link></li>
                        <li className="nav-item">
                            <button onClick={selectlanguage} className="btn nav-link">
                                <FaGlobe className="me-2" /> {t('language')} ({currentLanguage.toUpperCase()})
                            </button>
                        </li>
                        <hr />
                        <li className="fw-bold">{t('Electricité')}</li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Courant_Fort">{t('courantfort')}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Courant_Faible">{t('courantfaible')}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Audiovisuel">{t('Audiovisuel')}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Securite">{t('Securite')}</Link></li>
                        <hr />
                        <li className="fw-bold">{t('Energie renouvelable')}</li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Productiondenergie">{t("Production d'énergie")}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Stockagedenergie">{t("Stockage d'énergie")}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Gestiondenergie">{t("Gestion d'énergie")}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Maintenance">{t("Maintenance")}</Link></li>
                        <hr />
                        <li className="fw-bold">{t('Informatique')}</li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Developpement">{t("Developpement")}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-Creative-Branding">{t('Service Creative & Branding')}</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/service-ServiceItSolutions">{t("IT Solutions")}</Link></li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default MobileSidebar;
